import { useCallback, useEffect, useState } from 'react';

import {
  getAutopasteLocalStorage,
  setAutopasteLocalStorage,
} from '../localStorage/autopasteLocalStorage';
import {
  notifyAutopasteExtension,
  AUTOPASTE_APP_SOURCE,
  AUTOPASTE_EXTENSION_MESSAGE,
} from '../extension/autopasteExtension';

export default function useAutopaste() {
  const [enabled, setEnabled] = useState(getAutopasteLocalStorage);

  const handleChange = useCallback((checked: boolean) => {
    setEnabled(checked);
    setAutopasteLocalStorage(checked);
    notifyAutopasteExtension(checked);
  }, []);

  useEffect(() => {
    notifyAutopasteExtension(enabled);
  }, [enabled]);

  useEffect(() => {
    const handleExtensionSync = (event: MessageEvent) => {
      if (event.source !== window || event.origin !== window.location.origin) {
        return;
      }

      const data = event.data;
      if (
        data?.source === AUTOPASTE_APP_SOURCE &&
        data?.type === AUTOPASTE_EXTENSION_MESSAGE.ENABLED_CHANGED &&
        typeof data.enabled === 'boolean'
      ) {
        setEnabled(data.enabled);
        setAutopasteLocalStorage(data.enabled);
      }
    };

    window.addEventListener('message', handleExtensionSync);

    return () => {
      window.removeEventListener('message', handleExtensionSync);
    };
  }, []);

  return { enabled, handleChange };
}
